var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"filter-label"},[_vm._v(" Alert Category ")]),_c('div',{staticClass:"filter-options"},[_c('SACCheckbox',{attrs:{"label":"Performance","field":"alertType","checked":_vm.existingAlertCategory.includes('Performance'),"change":() => _vm.handleSystemFilters(
        'alertCategoryFilter',
        'Performance',
        !!_vm.existingAlertCategory.includes('Performance'))}}),_c('SACCheckbox',{attrs:{"label":"Leak","field":"alertType","checked":_vm.existingAlertCategory.includes('Leak'),"change":() => _vm.handleSystemFilters(
        'alertCategoryFilter',
        'Leak',
        !!_vm.existingAlertCategory.includes('Leak'))}}),_c('SACCheckbox',{attrs:{"label":"Filter","field":"alertType","checked":_vm.existingAlertCategory.includes('Filter'),"change":() => _vm.handleSystemFilters(
        'alertCategoryFilter',
        'Filter',
        !!_vm.existingAlertCategory.includes('Filter'))}}),_c('SACCheckbox',{attrs:{"label":"Device","field":"alertType","checked":_vm.existingAlertCategory.includes('Device'),"change":() => _vm.handleSystemFilters(
        'alertCategoryFilter',
        'Device',
        !!_vm.existingAlertCategory.includes('Device'))}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }